import React from "react";
import "./appThumb.css";
import { IMAGE_APP_LAYERS, IMAGE_APP_MOBILE } from "../images";

const colors = ["green", "yellow", "purple", "blue", "brown"];

const shapes = ["round", "normal"];

const backgrounds = [IMAGE_APP_LAYERS, IMAGE_APP_MOBILE];

const calcBack = (number) => {
  // Default to 1 to use IMAGE_APP_MOBILE if number is null, undefined, or NaN
  const num = parseInt(number) || 1;
  const index = num % backgrounds.length;
  return backgrounds[index];
};

// eslint-disable-next-line no-unused-vars
const calcColor = (number) => {
  const index = parseInt(number) % colors.length;
  return colors[index];
};

// eslint-disable-next-line no-unused-vars
const calcShape = () => {
  return shapes[1];
};

const Thumb = (props) => {
  const { number, style, className } = props;
  return (
    <img
      style={style}
      className={className}
      src={calcBack(number)}
      alt="application thumb image"
    />
  );
};

export default Thumb;
